import { render, staticRenderFns } from "./ProjectMemberEditor.vue?vue&type=template&id=7903a85f&scoped=true&"
import script from "./ProjectMemberEditor.vue?vue&type=script&lang=js&"
export * from "./ProjectMemberEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMemberEditor.vue?vue&type=style&index=0&id=7903a85f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7903a85f",
  null
  
)

export default component.exports